import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material UI
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import ReminderIcon from '@material-ui/icons/Alarm';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';

import { markCandidateRemindersAsDoneURL, deleteCandidateRemindersURL } from '../constants';
import { formatDateToDELocaleTime } from '../utils/utilFunctions';
import { markCandidateRemindersAsDone, deleteCandidateReminders } from '../reminders/api/candidateReminderAPI';

const CandidateReminderListItem = ({
  id,
  title,
  description,
  dueDate,
  candidateId,
  candidateName,
  isRead,
  onIsReadButtonClick,
  onDeleteButtonClick,
  errorHandling
}) => {
  const handleMarkAsRead = useCallback(async () => {
    try {
      await markCandidateRemindersAsDone([id]);
      onIsReadButtonClick(true);
    } catch (err) {
      errorHandling(err, markCandidateRemindersAsDoneURL);
    }
  }, [id, onIsReadButtonClick, errorHandling]);

  const handleDelete = useCallback(async () => {
    try {
      await deleteCandidateReminders([id]);
      onDeleteButtonClick(true);
    } catch (err) {
      errorHandling(err, deleteCandidateRemindersURL);
    }
  }, [id, onDeleteButtonClick, errorHandling]);

  return (
    <ListItem button style={isRead ? { backgroundColor: '#e8e8e8' } : {}} component={Link} to={`/candidates?id=${candidateId}&t=4`}>
      <ListItemAvatar>
        <Avatar>
          <ReminderIcon />
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <span>
            <span style={{ fontWeight: '500' }}>{title}: </span>
            {candidateName && `Kandidat: ${candidateName} `}
            {description.length > 0 && `Beschreibung: ${description}`}
          </span>
        }
        secondary={dueDate ? formatDateToDELocaleTime(new Date(dueDate)) : ''}
      />
      <ListItemSecondaryAction>
        <IconButton aria-label="mark_unread" onClick={handleMarkAsRead}>
          {isRead ? <DoneIcon color="primary" /> : <DoneIcon />}
        </IconButton>
        <IconButton aria-label="Delete" onClick={handleDelete}>
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

CandidateReminderListItem.defaultProps = {
  candidateName: '',
  candidateId: ''
};

CandidateReminderListItem.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  dueDate: PropTypes.string.isRequired,
  candidateId: PropTypes.string,
  candidateName: PropTypes.string,
  isRead: PropTypes.bool.isRequired,
  onIsReadButtonClick: PropTypes.func.isRequired,
  onDeleteButtonClick: PropTypes.func.isRequired,
  errorHandling: PropTypes.func.isRequired
};

export default CandidateReminderListItem;
